export { default as FormView } from 'import/components/ImportFormView';
export { default as ListView } from 'import/components/ImportListView';



// WEBPACK FOOTER //
// src/modules/secured/modules/import/components/index.js